import { Avatar, Space, Typography } from "antd";

import React from "react";
const { Text } = Typography;

export const DropDownListContent = ({
  page_name,
  page_id,
  avatar,
  select_action = () => {},
}) => {
  return (
    <Space className="bg-white p-2 rounded-md">
      <Avatar src={avatar} size={40} className="rounded-full" />
      <Space direction="vertical" size={0}>
        <Text strong className="text-gray-900">
          {page_name}
        </Text>
        <Text type="secondary" className="text-sm">
          Facebook page: {page_id}
        </Text>
      </Space>
    </Space>
  );
};
